import React from 'react';
import s from './styles.module.css'
import {Box, Modal} from "@mui/material";

const style = {
    display: "flex",
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    border: 'none',
    boxShadow: 24,
    p: 4,
    borderRadius: '3px',
    maxWidth: '95%',
    width: '100%',
    height: '100%',
    maxHeight: '90%',
};

const ModalStatus = ({status, open,isBrigade = false}) => {
    return (
        <Modal
            open={open}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                {status === 'stop' && <div className={s.text_box}>
                    <h1>Соревнование остановлено, ожидайте</h1>
                </div>}
                {status === 'wait' && <div className={s.text_box}>
                    {isBrigade ? <h1>Ожидайте подтверждения для перехода к <br/> судейству следующей фигуры</h1> :<h1>Ожидайте подтверждения для перехода к <br/> судейству следующей команды</h1>}
                </div>}
            </Box>
        </Modal>
    );
};

export default ModalStatus;
